import { IUser } from '@Data/users/Interfaces';
import { ITeam } from '../teams/Interfaces';
import { IOrganization } from './Interfaces';

export interface IOrganizationState {
    organizations: Array<IOrganization> | null;
    organizationMembers: Array<IUser>;
    organizationAdministrators: Array<IUser>;
    selectedOrganization: IOrganization | null;
    teams: Array<ITeam>;
}

export const initialOrganizationState: IOrganizationState = {
    organizations: null,
    organizationMembers: [],
    organizationAdministrators: [],
    selectedOrganization: null,
    teams: [],
};
